export default __webpack_public_path__ + "static/media/Screenshot_21.4426aca3.png";